import Month from '../models/months';
import MonthlyOffer from '../models/monthly-offer';

const offersCollection: MonthlyOffer[] = [
  // ##### TEMPLATE
  // {
  //   month: Month.XX,
  //   year: 2026,
  //   offers: [
  //     {
  //       title: '',
  //       description: '',
  //       imgFile: '.png',
  //       offerPrice: 0.0,
  //     },
  //     {
  //       title: '',
  //       description: '',
  //       imgFile: '.png',
  //       offerPrice: 0.0,
  //     },
  //     {
  //       title: '',
  //       description: '',
  //       imgFile: '.png',
  //       offerPrice: 0.0,
  //     },
  //   ],
  // },
  // #####
  {
    month: Month.May,
    year: 2026,
    offers: [
      {
        title: 'Aspirin plus C',
        description: '10 Braustabletten',
        imgFile: 'aspirinplusc_10brausetabletten.png',
        offerPrice: 6.99,
      },
      {
        title: 'Fenihydrocort 0,5%',
        description: '15 g Creme',
        imgFile: 'fenihydrocort.png',
        offerPrice: 8.99,
      },
      {
        title: 'Ciclopoli Nagellack',
        description: 'gegen Pilzbefall, 3,3 ml',
        imgFile: 'ciclopoli_gegen_nagelpilz_8%.jpg',
        offerPrice: 21.99,
      },
    ],
  },
];

export default offersCollection;
